[{
	"data": {
		"config": [{
			"otp_timeout": 181,
			"otp_attempt_limit": 5,
			"otp_resend_limit": 6,
			"otp_resend_limit_duration": 3600
		}],
		"title": [{
			"otp_title_sms": "Verify your mobile number",
			"otp_title_email": "Verify your email address"
		}],
		"feedback": [{
			"otp_feedback_msg_1": "To complete your service request,",
			"otp_feedback_msg_2": "please enter the OTP we sent to",
			"otp_feedback_msg_3_sms": "your mobile number",
			"otp_feedback_msg_3_email": "your email",
			"otp_feedback_msg_4": "within the next",
			"otp_feedback_msg_5": "minutes"
		}],
		"nonfeedback": [{
			"otp_nonfeedback_msg_0": "To complete your service request,",
			"otp_nonFeedback_msg_1": "please enter the OTP we sent to",
			"otp_nonFeedback_msg_2_sms": "your mobile number",
			"otp_nonFeedback_msg_2_email": "your email",
			"otp_nonFeedback_msg_3": "within the next",
			"otp_nonFeedback_msg_4": "minutes"
		}],
		"failed": [{
			"otp_failed_msg_1": "Invalid OTP. You have",
			"otp_failed_msg_2": "remaining attempts.",
			"otp_failed_msg_3": "Please try again"
		}],
		"interval": [{
			"otp_interval_block_msg_1": "Cannot generate code at the moment. Please try again after",
			"otp_interval_block_msg_05": "Unavailable. Please try again after",
			"otp_interval_block_msg_2": "minutes"
		}],
		"noCode": [{
			"otp_no_code_msg": "Didn't receive a code?",
			"otp_no_code_msg2": "Resend Code"
		}],
		"cancel": [{
			"otp_cancel_msg": "Are you sure you want to cancel the OTP Verification?"
		}]
	}
}]